import { ReactElement } from 'react';

import { StyledFlex } from '@dreryk/react-components';

type ReceptionServiceAdvancePaymentProps = { readonly amount: ReactElement };

export const ReceptionServiceAdvancePayment = (props: ReceptionServiceAdvancePaymentProps): JSX.Element => {
   return (
      <StyledFlex gap={20} direction={'column'}>
         {/* TODO DREGAB-20795 Dodanie komunikatu z ostrzeżeniem o włączeniu usługi płatności online 
         {/* <ReceptionServiceAdvancePaymentStatus /> */}
         {props.amount}
      </StyledFlex>
   );
};
